import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "./context/AuthContext";
import { FIREBASE_DB } from "./firebase.config";
import { collection, query, where, getDocs } from "firebase/firestore";
import { Briefcase, MapPin, Clock, ArrowRight } from "lucide-react";

export const API_URL =
  process.env.REACT_APP_API_URL || "https://sbg-backend.onrender.com";

const SavedJobs = () => {
  const [savedJobs, setSavedJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { currentUser } = useAuth();

  useEffect(() => {
    const fetchSavedJobs = async () => {
      if (!currentUser) return;

      try {
        setLoading(true);
        // Fetch saved job IDs from Firebase
        const q = query(
          collection(FIREBASE_DB, "savedJobs"),
          where("userId", "==", currentUser.uid)
        );
        const querySnapshot = await getDocs(q);
        const savedJobIds = querySnapshot.docs.map((doc) => doc.data().jobId);

        // Fetch job details from MongoDB API
        const jobPromises = savedJobIds.map((id) =>
          fetch(`${API_URL}/jobs/${id}`).then((res) => res.json())
        );
        const jobs = await Promise.all(jobPromises);

        setSavedJobs(jobs);
      } catch (error) {
        console.error("Error fetching saved jobs:", error);
        setError("Failed to load saved jobs. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    fetchSavedJobs();
  }, [currentUser]);

  if (loading)
    return <div className="text-center mt-8">Loading saved jobs...</div>;
  if (error)
    return <div className="text-center mt-8 text-red-600">{error}</div>;
  if (savedJobs.length === 0)
    return <div className="text-center mt-8">No saved jobs found.</div>;

  return (
    <div className="container mx-auto px-4 py-8">
      <h2 className="text-3xl font-bold mb-6">Saved Jobs</h2>
      <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
        {savedJobs.map((job) => (
          <div
            key={job._id}
            className="bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition-shadow"
          >
            <h3 className="text-xl font-semibold mb-2">{job.title}</h3>
            <p className="text-gray-600 mb-4">{job.company}</p>
            <div className="flex items-center text-gray-500 mb-2">
              <MapPin className="w-4 h-4 mr-2" />
              <span>{job.location}</span>
            </div>
            <div className="flex items-center text-gray-500 mb-2">
              <Briefcase className="w-4 h-4 mr-2" />
              <span>{job.jobType}</span>
            </div>
            <div className="flex items-center text-gray-500 mb-4">
              <Clock className="w-4 h-4 mr-2" />
              <span>
                Posted on {new Date(job.postedDate).toLocaleDateString()}
              </span>
            </div>
            <Link
              to={`/job/${job._id}`}
              className="inline-flex items-center text-blue-600 hover:text-blue-800"
            >
              View Details
              <ArrowRight className="w-4 h-4 ml-1" />
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SavedJobs;
